<div class="outer-image-upload-wrapper">
  <div class="croppie-section" [style.width]="widthRatio">
    <div class="cropping-ratio" [style.padding-bottom]="heightRatio">
      <ng-container *ngIf="spinnerOn">
        <div class="upload-image-wrapper">
          <div class="upload-rectangle">
            <div class="cnt-button upload-image">
              <div class="upload-button-content">
                <div class="svg-wrapper">
                  <ion-spinner name="circular"></ion-spinner>
                </div>
                <div class="cnt-button-copy">Uploading Photo</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!spinnerOn && !currentImage && options?.croppieOptions?.viewport?.type === 'circle'">
        <button type="button" (click)="selectImage()" class="photo-upload">
          <div class="upload-image-wrapper">
            <div class="upload-rectangle">
              <div class="cnt-button upload-image">
                <div class="upload-button-content">
                  <div class="svg-wrapper">
                    <curbnturf-misc-svg icon="camera"></curbnturf-misc-svg>
                  </div>
                  <div class="cnt-button-copy" [innerHTML]="text"></div>
                </div>
              </div>
            </div>
          </div>
        </button>
      </ng-container>
      <ng-container *ngIf="!spinnerOn && !currentImage && options?.croppieOptions?.viewport?.type !== 'circle'">
        <button type="button" class="full" (click)="selectImage()">
          <div class="upload-image-wrapper">
            <div class="upload-rectangle">
              <div class="cnt-button upload-image">
                <div class="upload-button-content">
                  <div class="svg-wrapper">
                    <curbnturf-misc-svg icon="camera"></curbnturf-misc-svg>
                  </div>
                  <div class="cnt-button-copy" [innerHTML]="text"></div>
                </div>
              </div>
            </div>
          </div>
        </button>
      </ng-container>
      <ng-container *ngIf="isString(currentImage)">
        <img class="img-fluid" [src]="imageToDisplay" alt="Uploaded Image" />
      </ng-container>
    </div>
  </div>
</div>
